import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import LogoCarousel from '../components/LogoCarousel';
import Pillars from '../components/Pillars';
import FeatureSection from '../components/FeatureSection';
import AutomateSection from '../components/AutomateSection';
import IndustriesSection from '../components/IndustriesSection';
import FAQ from '../components/FAQ';
import BookingSection from '../components/BookingSection';
import Footer from '../components/Footer';
import { MARKETING_TOOLS, CRM_TOOLS, SALES_TOOLS, AUTOMATION_TOOLS } from '../mock';

export default function LandingPage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <LogoCarousel />
        <Pillars />

        <section className="py-14 bg-white text-center">
          <div className="max-w-3xl mx-auto px-6 fade-in">
            <div className="text-sm font-bold tracking-[0.25em] uppercase text-neutral-500 mb-3">From Foundation To Functionality</div>
            <h2 className="text-3xl md:text-4xl font-black text-black leading-tight">
              Your business deserves tools that are as strong as your ambitions.
            </h2>
            <p className="mt-4 text-neutral-600">Each pillar comes packed with features designed to simplify your operations, save time, and drive results.</p>
          </div>
        </section>

        <FeatureSection
          eyebrow="Tools For"
          title="Marketing & Sales"
          subtitle="Reach the right audience, elevate your brand, and turn visitors into customers with tools tailored for growth."
          tools={MARKETING_TOOLS}
        />

        <FeatureSection
          eyebrow="Tools For"
          title="CRM & Customer Management"
          subtitle="Stay organized, nurture leads, and deliver exceptional experiences with streamlined customer management."
          tools={CRM_TOOLS}
        />

        <FeatureSection
          eyebrow="Tools For"
          title="Sales & Revenue Optimization"
          subtitle="Close deals faster, manage payments seamlessly, and unlock new revenue streams with smart optimization tools."
          tools={SALES_TOOLS}
        />

        <AutomateSection />

        <FeatureSection
          eyebrow="Tools For"
          title="AI, Automations & Insights"
          subtitle="Say goodbye to repetitive tasks and hello to smarter decisions with data-driven automation."
          tools={AUTOMATION_TOOLS}
        />

        <IndustriesSection />
        <FAQ />
        <BookingSection />
      </main>
      <Footer />
    </>
  );
}
